<template>
  <app-content>
    <form action="#">
      <div class="inner">
        <p class="buttons">
          <app-button-delete @click="deleteItem" v-if="!newItem"/>
        </p>
        <app-content-title v-if="!newItem && !pending"
                           :title="item.name"/>
        <app-content-title v-if="newItem" :title="translations.newBlackoutContent"/>
      </div>
      <app-settings @submit="onFormSubmit" :disabled="pending">
      <div :title="translations.information">
          <app-settings-content>
            <app-settings-desc :title="translations.basicInfo">
              <p v-if="!newItem">
                <translate>Založeno</translate>
                :<br/>
                <span v-html="formatDateAdvanced(item._created)"/>
              </p>

              <p v-if="!newItem">
                <translate>Upraveno</translate>
                :<br/>
                <span v-html="formatDateAdvanced(item._updated)"/>
              </p>

              <p v-if="!newItem && item._template">
                <translate>Založeno ze šablony</translate>
                :<br/>
                <a @click.stop="showTemplate">{{ item._template.show_name }} (#{{ item._template.id }})</a>
              </p>
            </app-settings-desc>

            <app-settings-options>
              <app-settings-col class="field_left">
                <app-input
                  :label="translations.name"
                  :error="errors.items.find(el => el.field === 'name')"
                  v-model="formItem.name"
                  name="name"
                />

                <app-settings-control>
                  <app-checkbox
                      name="enabled"
                      :title="translations.enabled"
                      :error="!!errors.first('enabled')"
                      v-model="formItem.enabled"
                  />
                </app-settings-control>

                <app-settings-select
                    required
                    :error="errors.items.find(el => el.field === 'epgId')"
                    :label="translations.tvStation"
                >
                  <app-select
                      selectId="epgId"
                      :options="tvStationsOptions"
                      v-model="formItem.epgId"
                      name="epgId"
                  />
                </app-settings-select>

                <app-input
                    required
                    :label.sync="translations.fromTimestamp"
                    :error="errors.items.find(el => el.field === 'fromTimestamp')"
                    v-model="formItem.fromTimestamp"
                    type="number"
                    name="fromTimestamp"
                />

                <app-input
                    required
                    :label="translations.toTimestamp"
                    :error="errors.items.find(el => el.field === 'toTimestamp')"
                    v-model="formItem.toTimestamp"
                    type="number"
                    name="toTimestamp"
                />
              </app-settings-col>

              <app-settings-col class="field_right">
                <app-input
                    :label="translations.reason"
                    :error="errors.items.find(el => el.field === 'reason')"
                    v-model="formItem.reason"
                    name="reason"
                />

                <app-settings-control>
                  <app-checkbox
                      name="reflectOverlaps"
                      :title="translations.reflectOverlaps"
                      :error="!!errors.first('reflectOverlaps')"
                      v-model="formItem.reflectOverlaps"
                  />
                </app-settings-control>

                <app-settings-control>
                  <app-checkbox
                      name="allowCatchup"
                      :title="translations.allowCatchup"
                      :error="!!errors.first('allowCatchup')"
                      v-model="formItem.allowCatchup"
                  />
                </app-settings-control>

                <app-settings-control>
                  <app-checkbox
                      name="allowTs"
                      :title="translations.allowTs"
                      :error="!!errors.first('allowTs')"
                      v-model="formItem.allowTs"
                  />
                </app-settings-control>

                <app-settings-control>
                  <app-checkbox
                      name="allowPvr"
                      :title="translations.allowPvr"
                      :error="!!errors.first('allowPvr')"
                      v-model="formItem.allowPvr"
                  />
                </app-settings-control>
              </app-settings-col>
            </app-settings-options>
          </app-settings-content>
      </div>
      <div :title="translations.regionSettings">
        <app-settings-content>
          <app-settings-desc :title="translations.regionSettings" />

          <app-settings-options>
            <app-settings-col class="field_left">
                <app-input
                    :label="translations.allowedRegions"
                    :error="errors.items.find(el => el.field === 'allowedRegions')"
                    v-model="formItem.allowedRegions"
                    name="allowedRegions"
                />
            </app-settings-col>

            <app-settings-col class="field_right">
              <app-input
                  :label="translations.restrictedRegions"
                  :error="errors.items.find(el => el.field === 'restrictedRegions')"
                  v-model="formItem.restrictedRegions"
                  name="restrictedRegions"
              />
            </app-settings-col>
          </app-settings-options>
        </app-settings-content>

        </div>
        <div :title="translations.backofficeRelations">
          <app-settings-content v-if="backofficesList.length > 0">
            <app-settings-desc :title="translations.backofficeRelations" />

            <div class="right checkbox_group">
              <ul>
                <app-checkbox
                    v-for="backoffice in backofficesList"
                    list
                    :title="backoffice.name"
                    :key="backoffice.id"
                    :formValue="backoffice.id"
                    :checked="formItem.backofficeIds && formItem.backofficeIds.includes(backoffice.id)"
                    name="backofficeIds[]"
                />
              </ul>
            </div>

          </app-settings-content>

          <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'blackoutContents' }">
            <app-content-save-button :disabled="pending" @click="disallowBack"/>
          </app-settings-buttons>
        </div>
      </app-settings>
    </form>
  </app-content>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { getCommonFormSubmit } from 'utils/form'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'BlackoutContent',
  parentRouteName: 'blackoutContents',
  storeModuleName: 'blackoutContents',
  storeItemName: 'blackoutContent'
})

export default {
  name: 'blackout-content-item',
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  created() {
    if (typeof this.formItem.enabled === 'undefined') {
      this.formItem.enabled = true
      this.formItem.reflectOverlaps = true
    }

    this.getTvStationsOrderedByName()
    this.getBackoffices()
  },
  methods: {
    ...mapActions([
      'getTvStations',
      'getBackoffices'
    ]),
    showTemplate() {
      this.$router.push({
        name: 'blackoutContentTemplate',
        params: {
          id: this.item._template.id
        }
      })
    },
    getTvStationsOrderedByName() {
      this.getTvStations({
        params: {
          order: 'name',
          limit: 100000
        }
      })
    },
    async onFormSubmit(e) {
      this.errors.clear()

      this.formErrors = await this.runValidation()
      if (this.formErrors.items.length > 0) {
        this.appShowErrors(this.formErrors.items.map(v => v.msg))
        return
      }

      const commonFormSubmit = getCommonFormSubmit('BlackoutContent')
      const response = await
      commonFormSubmit(this, e).catch(err => err.response)

      this.handleResponseIfError(response)

      if (!this.backAllowed && response.status === 201) {
        this.goToDetail(response.data.data._id)
      }
    },
    async runValidation() {
      await this.errors.clear()
      await this.$validator.validateAll()
      return this.errors
    }
  },
  computed: {
    ...mapState({
      tvStationsOptions: (state, vm) => {
        return [
          ...state.tvStations.tvStations.map(({ _id, name, countryId }) => ({
            value: _id,
            name: name + ' (#' + _id + ')',
            country: countryId
          }))
        ]
      },
      backofficesList: (state, vm) => {
        return [
          ...state.backoffices.backoffices.map(({ _id, name }) => ({
            id: _id,
            name: name
          }))
        ]
      }
    }),
    translations() {
      return {
        regionSettings: this.$gettext('Nastavení regionů'),
        backofficeRelations: this.$gettext('Backoffice'),
        newBlackoutContent: this.$gettext('Nový blokovaný obsah'),
        fromTimestamp: this.$gettext('Blokovat od (UTC timestamp)'),
        toTimestamp: this.$gettext('Blokovat do (UTC timestamp)'),
        tvStation: this.$gettext('EPG Stanice'),
        reason: this.$gettext('Důvod blokace'),
        list: this.$gettext('Seznam'),
        enabled: this.$gettext('Blokování povoleno'),
        information: this.$gettext('Informace'),
        format: this.$gettext('Formát'),
        basicInfo: this.$gettext('Základní údaje'),
        reflectOverlaps: this.$gettext('Použít reálné overlapy'),
        allowCatchup: this.$gettext('Povolit catch-up'),
        allowTs: this.$gettext('Povolit Timeshift'),
        allowPvr: this.$gettext('Povolit PVR'),
        allowedRegions: this.$gettext('Povolené regiony'),
        restrictedRegions: this.$gettext('Zakázané regiony'),
        name: this.$gettext('Název'),
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('Blokovaný obsah'), link: { name: 'blackoutContents' } },
        this.item._id ? this.$gettext('Blokovaný obsah') : this.translations.newBlackoutContent
      ]
    }
  }
}
</script>
